import axios from "@/api/axios";

const roomList = (data) => {
    return axios
        .post('/admin/room/get-list', {room: data})
        .then(response => response.data)
}

const roomFullList = (data) => {
    return axios
        .post('/admin/room/get-full-list', {room: data})
        .then(response => response.data)
}

const roomGroupList = (data) => {
    return axios
        .post('/admin/room/get-group-list', {room: data})
        .then(response => response.data)
}

const roomCreate = (data) => {
    return axios
        .post('/admin/room/create', {room: data})
        .then(response => response.data)
}

const roomUpdate = (data) => {
    return axios
        .post('/admin/room/update', {room: data})
        .then(response => response.data)
}

const roomGroupCreate = (data) => {
    return axios
        .post('/admin/room/group-create', {room: data})
        .then(response => response.data)
}

const roomGroupUpdate = (data) => {
    return axios
        .post('/admin/room/group-update', {room: data})
        .then(response => response.data)
}

export default {
    roomList,
    roomFullList,
    roomGroupList,
    roomCreate,
    roomUpdate,
    roomGroupCreate,
    roomGroupUpdate
}